import React, { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import PermanentlyDeleteAllDocuments from "./PermanentlyDeleteAllDocuments";
import RestoreAllDocument from "./RestoreAllDocuments";

const Dropdown = ({
  selectedRows,
  isEntireTableRowsSelected,
  setDocumentRestoredToTrue,
  setDocumentDeletedToTrue,
}) => {
  const [open, setOpen] = useState(false);
  const [docId, setDocId] = useState();

  const changeDropdownVisibilityFunc = () => {
    setOpen(!open);
  };

  const handleSelectedRows = (selectedRows) => {
    setDocId(selectedRows);
  };

  return (
    <div className="dropdown-button">
      <IoMdArrowDropdown
        onClick={changeDropdownVisibilityFunc}
        style={{ visibility: selectedRows.length > 0 ? "visible" : "hidden" }}
      />
      <div
        className="elements"
        style={{
          display: open ? "block" : "none",
          zIndex: 10,
          marginTop: "3px",
        }}
      >
        <ul className="docs-dropdown-list">
          <li
            className="docs-dropdown-item"
            onClick={() => handleSelectedRows(selectedRows)}
          >
            <RestoreAllDocument
              setDocumentRestoredToTrue={setDocumentRestoredToTrue}
              isEntireTableRowsSelected={isEntireTableRowsSelected}
              changeDropdownVisibilityFunc={changeDropdownVisibilityFunc}
              id={docId}
            />
          </li>
          <li
            className="docs-dropdown-item"
            onClick={() => handleSelectedRows(selectedRows)}
          >
            <PermanentlyDeleteAllDocuments
              setDocumentDeletedToTrue={setDocumentDeletedToTrue}
              isEntireTableRowsSelected={isEntireTableRowsSelected}
              changeDropdownVisibilityFunc={changeDropdownVisibilityFunc}
              id={docId}
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
